import axios from 'axios';
import { route } from 'ziggy-js';

export async function updateCartCounter() {
    const { data } = await axios.get(route('dam.get-cart-assets'), {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    });

    document.querySelector('*[data-role=cartAssetCount]').innerHTML = data.length;
}
